var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-panel',{attrs:{"extra-class":"date-picker--panel-year","view":_vm.data},on:{"prev":_vm.onPrevDecades,"next":_vm.onNextDecades,"pick-cell":_vm.onPick},scopedSlots:_vm._u([{key:"panelTitle",fn:function(){return [_vm._t("title")]},proxy:true},{key:"header",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.startYear)+"年 - "+_vm._s(_vm.stopYear)+"年")])]},proxy:true},{key:"default",fn:function(ref){
var data = ref.data;
var row = ref.row;
var col = ref.col;
var html = ref.html;
return [_vm._t("default",null,{"data":data,"row":row,"col":col,"html":html})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }